import * as React from 'react'
import APageRow from '../../components/atoms/APageRow'
import MForm from '../../components/molecules/MForm'
import { apiConsumer, IApiConsumer } from '../../data/ApiProvider'
import AField from '../../components/atoms/AField'
import AButton from '../../components/atoms/AButton'


import AButtonGroup from '../../components/atoms/AButtonGroup'
import { createReport } from './reports.actions'

interface ICreateReport extends IApiConsumer {
    id: string
    onSuccess: (res: any) => void
    back: string,
}

class CreateReport extends React.Component<ICreateReport> {
    handleSubmit = (values: any) => {
        return this.props.dispatch(createReport(+this.props.id, { name: values.name, url: values.url})).then(res => {
            return this.props.onSuccess(res)
        })
    }

    render() {
        return (
            <APageRow >
                <MForm key="create_report" onSubmit={this.handleSubmit}>
                    <AField
                        name="name"
                        type="text"
                        placeholder='Name of the report'
                     />
                    <AField
                        name="url"
                        type="text"
                        placeholder="URL for the report"
                            
                    />
                    <AButtonGroup>
                    <AButton outline color="primary" to={this.props.back}>
                        Cancel
                    </AButton>
                    <AButton outline color="error" type="submit">
                        Create
                    </AButton>
                    </AButtonGroup>
                </MForm>
            </APageRow>
        )
    }
}

export default apiConsumer({
})(CreateReport)
